import styled from "styled-components"

export const InfosStyles = styled.section`
  padding: var(--sectionPadding) var(--borderSpacing);
  color: #000;
  background-color: #fff;

  .infofeatures__container {
    width: calc(100% + 60px);
    transform: translateX(-30px);
    /* max-width: 1230px; */
    margin-left: auto;
    margin-right: auto;

    @media (min-width: 1024px) {
      width: calc(100% + 150px);
      transform: translateX(-75px);
    }

    @media (min-width: 1152px) {
      width: 100%;
      transform: translateX(0);
    }

    &--scroll {
      overflow-x: scroll;
      display: flex;
      scroll-snap-type: x mandatory;

      &::-webkit-scrollbar {
        width: 14px;
        height: 14px;
      }
      &::-webkit-scrollbar-thumb {
        background: #ffc400;
        border-radius: 0px;
      }
      &::-webkit-scrollbar-thumb:hover {
        background: #ffc400;
      }
      &::-webkit-scrollbar-track {
        background: #ffffff;
        border-radius: 0px;
      }

      @media (min-width: 52px) {
        overflow-x: visible;
        flex-wrap: wrap;
        justify-content: center;
      }
    }
  }

  .infofeatures__item {
    flex: 0 0 80%;
    min-height: 408px;
    background-color: #fff;
    margin-right: 8px;
    margin-left: 8px;
    overflow: hidden;
    scroll-snap-align: start;
    scroll-margin-left: 25px;

    @media (min-width: 414px) {
      min-height: 434px;
    }

    @media (min-width: 768px) {
      min-height: 500px;
    }

    @media (min-width: 1024px) {
      min-height: 600px;
    }

    @media (min-width: 1152px) {
      min-height: 500px;
    }

    &:hover,
    &:focus {
      cursor: pointer;

      h2,
      p {
        color: #fff;
      }

      .infofeatures__item--img {
        transform: scale(1.1);
      }
    }

    > a {
      display: flex;
      width: 100%;
      height: 100%;
      align-items: flex-end;
      position: relative;
      text-decoration: none;
    }

    &--img {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 0;
      transition: transform 0.3s ease;
    }

    &--content {
      width: 100%;
      position: relative;
      z-index: 1;
      padding: 20px;
      background: rgba(61, 61, 61, 1.1);

      > * {
        &:first-child {
          margin-top: 0;
        }

        &:last-child {
          margin-bottom: 0;
        }
      }

      > h2 {
        color: #fff;
        font-size: var(--h2);
        margin-bottom: 20px;
      }

      > p {
        color: #fff;
        font-size: var(--p);
        margin-bottom: 40px;
      }
    }

    @media (min-width: 414px) {
      min-height: 434px;
    }

    @media (min-width: 768px) {
      flex-basis: 65%;
      min-height: 500px;
      margin-left: 15px;
      margin-right: 15px;
    }

    @media (min-width: 1024px) {
      flex-basis: 60%;
      min-height: 500px;
      margin-left: 20px;
      margin-right: 20px;
    }

    @media (min-width: 1152px) {
      flex: 0 0 calc((100% / 3) - 27px);
      margin-bottom: 40px;
      scroll-margin-left: 0;

      &:nth-of-type(3n + 0) {
        margin-right: 0;
      }
    }

    &:nth-child(1) {
      margin-left: 30px;

      @media (min-width: 1024px) {
        margin-left: 75px;
      }

      @media (min-width: 1152px) {
        margin-left: 0;
      }
    }

    &:last-child {
      position: relative;

      &:after {
        content: "";
        position: absolute;
        width: 30px;
        height: 30px;
        background-color: transparent;
        right: -30px;
        bottom: 0;

        @media (min-width: 1024px) {
          right: -75px;
          width: 75px;
        }

        @media (min-width: 1152px) {
          display: none;
        }
      }
    }
  }

  ` 


  
  export const BlogItemsStyles = styled.section`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    max-width: 910px;
    margin: 0 auto;
    justify-content: center;
    padding-top: var(--sectionPadding);
    padding-bottom: var(--sectionPadding);
  `
  
  export const BlogItemStyles = styled.article`
    flex: 1 1 auto;
    max-width: 375px;
    margin: 0px;
  
    h2 {
      font-weight: 700;
  
      &:hover,
      &:focus {
        a {
          color: var(--primary);
        }
      }
    }
  
    a {
      text-decoration: none;
      color: #fff;
      transition: color 0.3s;
      cursor: pointer;
    }
  
    .blogitem__meta {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  `
  
  export const BlogSingleStyles = styled.article`
    padding: var(--sectionPadding) var(--borderSpacing);
    max-width: 750px;
    margin: 0 auto;
    box-sizing: content-box;
  
    .blogsingle {
      &__title {
        font-size: var(--h2);
        margin-bottom: 5px;
      }
  
      &__date {
        margin-top: 20px;
        margin-bottom: 20px;
      }
  
      &__content {
        border-top: 2px solid var(--primary);
        padding-top: 0px;
      }
  
      &__back {
        padding-top: 40px;
      }
    }
  `
  




